<template>
	<div @click.self="$emit('close')" class="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm flex items-center justify-center z-20">
		<div class="popup-bg text-[var(--popup-text-color)] rounded-lg p-8 w-10/12 md:w-3/6 lg:w-1/3 xl:w-1/4 relative brightness-110">
			<button @click="$emit('close')" class="absolute top-4 right-4">
				<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkX : lightX" alt="Close Icon" class="w-3 h-3"/>
			</button>
			<h2 class="text-2xl font-archivomedium mb-4 text-center text-[var(--popup-text-color)]">
				Choose your theme
			</h2>

			<div class="flex justify-center items-center my-4 space-x-8">
				<label for="lightTheme" class="flex flex-col items-center cursor-pointer">
					<img src="../assets/LightTheme.png" alt="Light Theme" class="w-20 h-auto mb-2" />
					<div class="flex items-center">
						<input type="radio" id="lightTheme" name="theme" value="light" :checked="currentTheme === 'light'" @change="$emit('update:currentTheme', 'light')" class="mr-2"/>
						<span class="font-archivoregular text-[var(--secondary-text-color)]">
							Light
						</span>
					</div>
				</label>

				<label for="darkTheme" class="flex flex-col items-center cursor-pointer">
					<img src="../assets/Dark_Theme1.png" alt="Dark Theme" class="w-20 h-auto mb-2" />
					<div class="flex items-center">
						<input type="radio" id="darkTheme" name="theme" value="dark" :checked="currentTheme === 'dark'" @change="$emit('update:currentTheme', 'dark')" class="mr-2"/>
						<span class="font-archivoregular text-[var(--secondary-text-color)]">
							Dark
						</span>
					</div>
				</label>

				<label for="navyTheme" class="flex flex-col items-center cursor-pointer">
					<img src="../assets/NavyTheme.png" alt="Navy Theme" class="w-20 h-auto mb-2" />
					<div class="flex items-center">
						<input type="radio" id="navyTheme" name="theme" value="navy" :checked="currentTheme === 'navy'" @change="$emit('update:currentTheme', 'navy')" class="mr-2"/>
						<span class="font-archivoregular text-[var(--secondary-text-color)]">
							Navy
						</span>
					</div>
				</label>
			</div>
		</div>
	</div>
</template>

<script setup>
	import lightX from '../assets/X.png';
	import darkX from '../assets/XWhite.png';

	const props = defineProps({
		currentTheme: { type: String, required: true }
	});

	const emit = defineEmits([
		'update:currentTheme',
		'close'
	]);
</script>

<style scoped>
	.popup-bg {
		background: var(--popup-bg-color);
	}
</style>
